import { SelectionAddress } from '../internal';
/**
 * @ignore
 */
export const SelectionWithAddressMixin = (Base) => class extends Base {
    getAddress() {
        return this.get("ADDR" /* Tag.Address */, null, SelectionAddress);
    }
    getPhoneNumber() {
        return this.get("PHON" /* Tag.Phone */);
    }
    getEmailAddress() {
        return this.get("EMAIL" /* Tag.Email */);
    }
    getFaxAddress() {
        return this.get("FAX" /* Tag.Fax */);
    }
    getWebAddress() {
        return this.get("WWW" /* Tag.Web */);
    }
};
//# sourceMappingURL=SelectionWithAddressMixin.js.map